/* Extracted from sections/home-collection-split.liquid so it ships as a cached asset instead of inline JS. */
/* Click-and-drag to scroll on desktop (mobile already has native touch swipe).
     Matches the grab-cursor drag behaviour the Swiper carousels use. Generic: any
     element with [data-drag-scroll] gets it, initialised once per page. */
  (function () {
    if (window.__dragScrollInit) return;
    window.__dragScrollInit = true;

    function bind(rail) {
      var down = false, startX = 0, startLeft = 0, moved = 0, vel = 0, raf = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;      // let native touch scrolling handle it
        cancelAnimationFrame(raf);
        down = true; moved = 0; vel = 0;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
      });

      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          rail.setPointerCapture(e.pointerId);
          moved = Math.abs(dx);
          var next = startLeft - dx;
          vel = next - rail.scrollLeft;          /* px moved since last frame */
          rail.scrollLeft = next;
          e.preventDefault();
        }
      });

      function end() {
        if (!down) return;
        down = false;
        /* Coast to a stop instead of halting the instant the button releases —
           the dead stop is what made these rails feel wrong to drag. */
        if (Math.abs(vel) > 1) {
          cancelAnimationFrame(raf);
          var v = vel;
          var glide = function () {
            v *= 0.94;
            rail.scrollLeft += v;
            if (Math.abs(v) > 0.4) { raf = requestAnimationFrame(glide); }
            else { rail.classList.remove('is-dragging'); }
          };
          raf = requestAnimationFrame(glide);
        } else {
          rail.classList.remove('is-dragging');
        }
        vel = 0;
      }
      rail.addEventListener('pointerup', end);
      rail.addEventListener('pointercancel', end);
      rail.addEventListener('pointerleave', end);

      /* a drag shouldn't open the product it finished on */
      rail.addEventListener('click', function (e) {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
    }

    function init() { document.querySelectorAll('[data-drag-scroll]').forEach(bind); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
  })();
